import React from "react";

// Skeleton de carga: bloques shimmer que imitan el contenido.
// rows: cantidad de filas; card: true envuelve en una card.
export const SkeletonLines = ({ rows = 3 }) => (
  <div aria-hidden="true">
    {Array.from({ length: rows }).map((_, i) => (
      <span
        key={i}
        className="esen-skel mb-2"
        style={{ width: `${100 - (i % 3) * 18}%`, height: 14 }}
      ></span>
    ))}
  </div>
);

const SkeletonCard = ({ rows = 4, title = true }) => (
  <div className="card" aria-busy="true" aria-label="Cargando contenido">
    <div className="card-body">
      {title ? (
        <span className="esen-skel mb-3" style={{ width: "40%", height: 20 }}></span>
      ) : null}
      <SkeletonLines rows={rows} />
    </div>
  </div>
);

export default SkeletonCard;
